<app-mock-switch></app-mock-switch>
<app-mock-values></app-mock-values>
<router-outlet></router-outlet>
